import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Tag } from 'primereact/tag';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { Checkbox } from 'primereact/checkbox';
import { Divider } from 'primereact/divider';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { useDataTable, useDialogCrup, ToastService } from '@iamsoftware/react-hooks';
import { AgreementConfigService as Service } from './AgreementConfigService';
import { CommonService } from '../../service/CommonService';

export const DocumentConfig: React.FC = () => {
  const [totalRecords, setTotalRecords] = useState(0);
  const [agreementNoFormatOptions, setAgreementNoFormatOptions] = useState<any[]>([]);
  const [items, setItems] = useState<any[]>([]);
  const [editingItem, setEditingItem] = useState<any>(null);
  const [itemDialogVisible, setItemDialogVisible] = useState(false);
  const [newItem, setNewItem] = useState<any>({
    sequenceNum: 1,
    description: '',
    isRequire: 'N'
  });
  const tabs = [
    { label: 'Đang sử dụng', statusId: 'AGT_CFG_ACTIVE' },
    { label: 'Ngừng sử dụng', statusId: 'AGT_CFG_INACTIVE' },
    { label: 'Đã xóa', statusId: 'AGT_CFG_DELETED' }
  ];
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const getStatusFilter = () => {
    const currentTab = tabs[activeTabIndex];
    if (currentTab?.statusId === 'AGT_CFG_ACTIVE') {
      return ['AGT_CFG_ACTIVE', 'AGT_CFG_CREATED'];
    }
    return currentTab?.statusId;
  };
  const statusFilter = getStatusFilter();
  const [isNewItemStarted, setIsNewItemStarted] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [isViewMode, setIsViewMode] = useState(false);

  const autoCreateNewRow = (itemToAdd: any) => {
    if (!itemToAdd.description || !itemToAdd.description.trim()) {
      return false;
    }

    if (isNewItemStarted) {
      return false;
    }

    setIsNewItemStarted(true);
    const formValue = form?.getValue?.() || {};
    const agreementConfigureEnumId = currentAgreementConfigureEnumId || formValue?.agreementConfigureEnumId;
    const itemData = {
      agreementConfigureEnumId: agreementConfigureEnumId || 'TEMP',
      sequenceNum: itemToAdd.sequenceNum || 1,
      description: itemToAdd.description.trim(),
      isRequire: itemToAdd.isRequire || 'N'
    };

    let maxSeq = 1;
    setItems((prevItems) => {
      const allSeqs = [...prevItems.map((item: any) => item.sequenceNum || 0), itemData.sequenceNum];
      maxSeq = allSeqs.length > 0 ? Math.max(...allSeqs) : itemData.sequenceNum;
      return [...prevItems, itemData];
    });

    setTimeout(() => {
      setNewItem({
        sequenceNum: maxSeq + 1,
        description: '',
        isRequire: 'N'
      });
      setIsNewItemStarted(false);
    }, 0);

    return true;
  };
  const [currentAgreementConfigureEnumId, setCurrentAgreementConfigureEnumId] = useState<string | null>(null);
  const [agreementConfigureEnumIdValue, setAgreementConfigureEnumIdValue] = useState<string>('');
  const [agreementConfigureEnumIdError, setAgreementConfigureEnumIdError] = useState<string | null>(null);
  const dataKey = 'agreementPartyTypeConfId';
  const header = 'Danh sách loại tài liệu';

  const getAgreementConfigureEnumId = () => {
    const formValue = form?.getValue?.() || {};
    return (agreementConfigureEnumIdValue || formValue?.agreementConfigureEnumId || '').trim();
  };

  const validateAgreementConfigureEnumId = (value: string) => {
    if (!value) {
      setAgreementConfigureEnumIdError('Mã loại tài liệu không được bỏ trống.');
      return false;
    }
    setAgreementConfigureEnumIdError(null);
    return true;
  };

  useEffect(() => {
    CommonService.getPseudoIdFormat().then((data: any) => {
      if (data?.listData) {
        setAgreementNoFormatOptions(data.listData.map((item: any) => ({
          value: item.enumId,
          label: item.description
        })));
      }
    }).catch(() => { });
  }, []);

  const handleDelete = async (rowData: any) => {
    try {
      const res = await Service.delete(rowData[dataKey]);
      if (res && res.success === 'Y') {
        ToastService.success('Đã xóa cấu hình');
        reloadLazyData();
      } else {
        ToastService.error(res?.error || 'Không thể xóa cấu hình');
      }
    } catch (e) {
      ToastService.error('Có lỗi khi xóa cấu hình');
    }
  };

  const handleExpire = async (rowData: any) => {
    try {
      const res = await Service.expire(rowData[dataKey]);
      if (res && res.success === 'Y') {
        ToastService.success('Đã ngừng sử dụng cấu hình');
        reloadLazyData();
      } else {
        ToastService.error(res?.error || 'Không thể ngừng sử dụng cấu hình');
      }
    } catch (e) {
      ToastService.error('Có lỗi khi ngừng sử dụng cấu hình');
    }
  };

  const handleActivate = async (rowData: any) => {
    try {
      const res = await Service.activate(rowData[dataKey]);
      if (res && res.success === 'Y') {
        ToastService.success('Đã kích hoạt lại cấu hình');
        reloadLazyData();
      } else {
        ToastService.error(res?.error || 'Không thể kích hoạt cấu hình');
      }
    } catch (e) {
      ToastService.error('Có lỗi khi kích hoạt cấu hình');
    }
  };

  const handleRestore = async (rowData: any) => {
    try {
      const res = await Service.restore(rowData[dataKey]);
      if (res && res.success === 'Y') {
        ToastService.success('Đã khôi phục cấu hình');
        reloadLazyData();
      } else {
        ToastService.error(res?.error || 'Không thể khôi phục cấu hình');
      }
    } catch (e) {
      ToastService.error('Có lỗi khi khôi phục cấu hình');
    }
  };

  const statusBodyTemplate = (rowData: any) => {
    const statusId = rowData.statusId;
    if (statusId === 'AGT_CFG_ACTIVE') {
      return <Tag value="Đang sử dụng" severity="success" />;
    } else if (statusId === 'AGT_CFG_INACTIVE') {
      return <Tag value="Ngừng sử dụng" severity="warning" />;
    } else if (statusId === 'AGT_CFG_CREATED') {
      return <Tag value="Mới tạo" severity="info" />;
    } else if (statusId === 'AGT_CFG_DELETED') {
      return <Tag value="Xóa bỏ" severity="danger" />;
    }
    return <Tag value="Không xác định" severity="secondary" />;
  };

  const loadItems = async (_agreementConfigureEnumId: string) => {
    const maxSeq = items && items.length > 0
      ? Math.max(...items.map((it: any) => it.sequenceNum || 0))
      : 0;
    setNewItem({
      ...newItem,
      sequenceNum: maxSeq + 1
    });
  };

  const handleEditItem = (item: any) => {
    if (item) {
      setEditingItem({
        sequenceNum: item.sequenceNum || 1,
        description: item.description || '',
        isRequire: item.isRequire || 'N'
      });
      setItemDialogVisible(true);
    }
  };

  const handleDeleteItem = (item: any) => {
    const filteredItems = items.filter(i => i.sequenceNum !== item.sequenceNum);
    const reorderedItems = filteredItems.map((i, idx) => ({
      ...i,
      sequenceNum: idx + 1
    }));
    setItems(reorderedItems);
    const maxSeq = reorderedItems.length > 0
      ? Math.max(...reorderedItems.map((item: any) => item.sequenceNum || 0))
      : 0;
    setNewItem({
      ...newItem,
      sequenceNum: maxSeq + 1
    });
  };

  const handleSaveItem = async () => {

    try {
      // Validate custom field trước khi submit
      const value = getAgreementConfigureEnumId();
      if (!validateAgreementConfigureEnumId(value)) {
        return;
      }
      const agreementConfigureEnumId = value;
      const formValue = form?.getValue?.() || {};

      const configData = {
        agreementConfigureName: formValue.agreementConfigureName,
        agreementConfigureEnumId,
        agreementNoFormatEnumId: formValue.agreementNoFormatEnumId,
        description: formValue.description
      };

      const itemData = {
        agreementConfigureEnumId,
        sequenceNum: editingItem.sequenceNum,
        description: editingItem.description || '',
        isRequire: editingItem.isRequire || 'N',
        config: configData,
        items: items
      };

      const res = await Service.saveItem(itemData);
      if (res && res.success === 'Y') {
        ToastService.success('Đã lưu item');
        setItemDialogVisible(false);
        setEditingItem(null);
        await loadItems(currentAgreementConfigureEnumId);
      } else {
        ToastService.error(res?.error || 'Không thể lưu item');
      }
    } catch (e: any) {
      ToastService.error('Có lỗi khi lưu item: ' + (e?.message || 'Unknown error'));
    }
  };

  const { render: renderDialogCrup, create, update, view, form } = useDialogCrup({
    header: 'Loại tài liệu',
    dataKey,
    fields: [
      { field: 'agreementConfigureName', header: 'Tên loại tài liệu', required: true, className: 'md:col-12' },
      {
        field: 'agreementConfigureEnumId',
        header: 'Mã loại tài liệu',
        required: true,
        className: 'md:col-6',
        type: 'custom',
        body: () => {
          const sanitizeAgreementCode = (rawValue: string = ''): string => {
            let value = rawValue.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
            value = value.toUpperCase().replace(/\s/g, '');
            return value;
          };

          const currentValue = agreementConfigureEnumIdValue || '';

          return (
            <div className="field">
              <label htmlFor="agreementConfigureEnumId" className="block text-900 font-medium mb-1">
                Mã loại tài liệu <span className="text-red-500">*</span>
              </label>
              <InputText
                id="agreementConfigureEnumId"
                value={currentValue}
                onInput={(e) => {
                  const inputEl = e.target as HTMLInputElement;
                  const value = sanitizeAgreementCode(inputEl.value);
                  if (value !== inputEl.value) inputEl.value = value;
                }}
                onChange={(e) => {
                  const value = sanitizeAgreementCode(e.target.value);
                  setAgreementConfigureEnumIdValue(value);
                  if (form) {
                    const updatedFormValue = form?.getValue?.() || {};
                    form?.setValue?.({ ...updatedFormValue, agreementConfigureEnumId: value });
                  }
                  if (agreementConfigureEnumIdError) {
                    validateAgreementConfigureEnumId(value);
                  }
                }}
                onBlur={() => validateAgreementConfigureEnumId(getAgreementConfigureEnumId())}
                className={`w-full ${agreementConfigureEnumIdError ? 'p-invalid' : ''}`}
              />
              {agreementConfigureEnumIdError && (
                <small className="p-error block mt-1">{agreementConfigureEnumIdError}</small>
              )}
            </div>
          );
        }
      },
      {
        field: 'agreementNoFormatEnumId',
        header: 'Định dạng mã tài liệu',
        required: true,
        className: 'md:col-6',
        type: 'Dropdown',
        DropdownProps: { options: agreementNoFormatOptions, optionLabel: 'label', optionValue: 'value', placeholder: 'Chọn định dạng' }
      },
      {
        field: 'description',
        header: 'Mô tả',
        className: 'md:col-12',
        type: 'InputTextarea',
        InputTextareaProps: {
          rows: 4,
          maxLength: 500,
          placeholder: 'Nhập mô tả lĩnh vực tài liệu',
          autoResize: true
        }
      },
      {
        field: 'items',
        header: 'Danh sách file đính kèm',
        className: 'md:col-12',
        type: 'custom',
        body: () => (
          <div className="mt-3" style={{ maxHeight: '400px', overflowY: 'auto' }}>
            <Divider />
            <div className="mb-3">
              <span className="text-lg font-semibold">Danh sách file đính kèm</span>
            </div>
            <div className="card" style={{ overflow: 'visible' }}>
              <div className="p-datatable-wrapper" style={{ overflow: 'visible' }}>
                <table className="p-datatable-table" style={{ width: '100%', tableLayout: 'auto' }}>
                  <thead>
                    <tr>
                      <th style={{ width: '50px', padding: '0.5rem' }}>STT</th>
                      <th style={{ padding: '0.5rem' }}>Mô tả</th>
                      <th style={{ width: '150px', padding: '0.5rem', textAlign: 'center' }}>Bắt buộc</th>
                      <th style={{ width: '120px', padding: '0.5rem', textAlign: 'center' }}>Thao tác</th>
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((item, index) => (
                      <tr key={`item-${item.sequenceNum}-${index}`}>
                        <td style={{ padding: '0.5rem' }}>
                          <InputNumber
                            value={item.sequenceNum}
                            disabled
                            min={1}
                            style={{ width: '100%' }}
                          />
                        </td>
                        <td style={{ padding: '0.5rem' }}>
                          <InputText
                            value={item.description || ''}
                            onChange={(e) => {
                              const newValue = e.target.value;
                              setItems((prevItems) => {
                                if (newValue === (prevItems[index]?.description || '')) {
                                  return prevItems;
                                }
                                const updatedItems = [...prevItems];
                                updatedItems[index] = { ...updatedItems[index], description: newValue };
                                return updatedItems;
                              });
                            }}
                            placeholder="Nhập mô tả"
                            style={{ width: '100%' }}
                            disabled={isViewMode}
                          />
                        </td>
                        <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                          <div className="flex align-items-center justify-content-center">
                            <Checkbox
                              inputId={`itemIsRequire_${index}`}
                              checked={item.isRequire === 'Y'}
                              onChange={(e) => {
                                const updatedItems = [...items];
                                updatedItems[index] = { ...updatedItems[index], isRequire: e.checked ? 'Y' : 'N' };
                                setItems(updatedItems);
                              }}
                              disabled={isViewMode}
                            />
                            <label htmlFor={`itemIsRequire_${index}`} className="ml-2">Bắt buộc</label>
                          </div>
                        </td>
                        <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                          {!isViewMode && (
                            <div className="flex gap-1 justify-content-center">
                              <Button
                                icon="pi pi-trash"
                                className="p-button-sm p-button-danger"
                                onClick={() => handleDeleteItem(item)}
                                tooltip="Xóa item"
                              />
                            </div>
                          )}
                        </td>
                      </tr>
                    ))}
                    {!isViewMode && (
                      <tr>
                        <td style={{ padding: '0.5rem' }}>
                          <InputNumber
                            value={newItem.sequenceNum}
                            disabled
                            min={1}
                            style={{ width: '100%' }}
                          />
                        </td>
                        <td style={{ padding: '0.5rem' }}>
                          <InputText
                            value={newItem.description}
                            onChange={(e) => {
                              if (!isNewItemStarted) {
                                setNewItem({ ...newItem, description: e.target.value });
                              }
                            }}
                            onBlur={(e) => {
                              if (isNewItemStarted) return;
                              const description = (e.target as HTMLInputElement).value;
                              if (description && description.trim()) {
                                const updatedItem = {
                                  ...newItem,
                                  description: description.trim(),
                                  sequenceNum: newItem.sequenceNum || 1
                                };
                                autoCreateNewRow(updatedItem);
                              }
                            }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.preventDefault();
                                if (isNewItemStarted) return;
                                const description = (e.target as HTMLInputElement).value;
                                if (description && description.trim()) {
                                  const updatedItem = {
                                    ...newItem,
                                    description: description.trim(),
                                    sequenceNum: newItem.sequenceNum || 1
                                  };
                                  if (autoCreateNewRow(updatedItem)) {
                                    setTimeout(() => {
                                      const inputs = document.querySelectorAll('input[placeholder="Nhập mô tả"]');
                                      const lastInput = inputs[inputs.length - 1] as HTMLInputElement;
                                      if (lastInput) {
                                        lastInput.focus();
                                        lastInput.select();
                                      }
                                    }, 200);
                                  }
                                }
                              }
                            }}
                            placeholder="Nhập mô tả"
                            style={{ width: '100%' }}
                          />
                        </td>
                        <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                          <div className="flex align-items-center justify-content-center">
                            <Checkbox
                              inputId="newItemIsRequire"
                              checked={newItem.isRequire === 'Y'}
                              onChange={(e) => {
                                setNewItem({ ...newItem, isRequire: e.checked ? 'Y' : 'N' });
                              }}
                            />
                            <label htmlFor="newItemIsRequire" className="ml-2">Bắt buộc</label>
                          </div>
                        </td>
                        <td style={{ padding: '0.5rem', textAlign: 'center' }}>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )
      },
    ],
    width: '80rem',
    createItem(item: any): Promise<any> {
      const formValue = form?.getValue?.() || {};
      const value = getAgreementConfigureEnumId();
      if (!validateAgreementConfigureEnumId(value)) {
        return Promise.reject(new Error('Mã loại tài liệu không được bỏ trống.'));
      }
      const agreementConfigureEnumId = value;
      const itemData = {
        ...item,
        agreementConfigureEnumId: agreementConfigureEnumId,
        items: items.map((it: any) => ({
          agreementConfigureEnumId: agreementConfigureEnumId,
          sequenceNum: it.sequenceNum,
          isRequire: it.isRequire,
          description: it.description
        }))
      };
      return Service.create(itemData)
        .then(async res => {
          if (res && res.success === 'Y') {
            ToastService.success('Đã tạo cấu hình thành công');
            setCurrentAgreementConfigureEnumId(agreementConfigureEnumId);
            await loadItems(agreementConfigureEnumId);
            setNewItem({
              sequenceNum: 1,
              description: '',
              isRequire: 'N'
            });
            reloadLazyData();
            return res;
          }
          throw new Error(res?.error || 'Không thể tạo cấu hình');
        })
        .catch((error: any) => {
          const message = error?.message || error?.response?.data?.error || 'Có lỗi khi tạo cấu hình';
          ToastService.error(message);
          throw (error instanceof Error ? error : new Error(message));
        });
    },
    updateItem(id: string, item: any): Promise<any> {
      const formValue = form?.getValue?.() || {};
      // Validate custom field trước khi submit
      const value = getAgreementConfigureEnumId();
      if (!validateAgreementConfigureEnumId(value)) {
        return Promise.reject(new Error('Mã loại tài liệu không được bỏ trống.'));
      }
      const agreementConfigureEnumId = value;
      const agreementPartyTypeConfId = formValue?.agreementPartyTypeConfId || item?.agreementPartyTypeConfId || id;
      const payloadItemsSource = Array.isArray(items) && items.length >= 0 ? items : [];
      const payloadItems = payloadItemsSource.map((it: any) => ({
        agreementConfigureEnumId: agreementConfigureEnumId,
        sequenceNum: it.sequenceNum,
        isRequire: it.isRequire,
        description: it.description
      }));
      const itemData = {
        ...item,
        agreementConfigureEnumId: agreementConfigureEnumId,
        items: payloadItems
      };
      return Service.update(agreementPartyTypeConfId, itemData)
        .then(async res => {
          if (res && res.success === 'Y') {
            setCurrentAgreementConfigureEnumId(agreementConfigureEnumId);

            const configData = {
              agreementConfigureName: formValue.agreementConfigureName,
              agreementConfigureEnumId: agreementConfigureEnumId,
              agreementNoFormatEnumId: formValue.agreementNoFormatEnumId,
              description: formValue.description
            };

            await loadItems(agreementConfigureEnumId);
            reloadLazyData();
            return res;
          }
          throw new Error(res?.error || 'Không thể cập nhật cấu hình');
        })
        .catch((error: any) => {
          const message = error?.message || error?.response?.data?.error || 'Có lỗi khi cập nhật cấu hình';
          ToastService.error(message);
          throw (error instanceof Error ? error : new Error(message));
        });
    }
  });

  const handleEdit = async (rowData: any) => {
    setAgreementConfigureEnumIdError(null);
    try {
      setDetailLoading(true);
      const agreementPartyTypeConfId = rowData.agreementPartyTypeConfId;
      if (!agreementPartyTypeConfId) {
        ToastService.error('Không tìm thấy ID cấu hình');
        return;
      }

      const res = await Service.get(agreementPartyTypeConfId);
      if (res && res.success === 'Y' && res.record) {
        const record = res.record;
        const itemsData = res.items || [];

        setCurrentAgreementConfigureEnumId(record.agreementConfigureEnumId);
        const recordEnumId = record.agreementConfigureEnumId || '';
        setAgreementConfigureEnumIdValue(recordEnumId);
        if (recordEnumId) {
          setAgreementConfigureEnumIdError(null);
        }
        setItems(itemsData || []);

        const maxSeq = itemsData && itemsData.length > 0
          ? Math.max(...itemsData.map((item: any) => item.sequenceNum || 0))
          : 0;
        setNewItem({
          sequenceNum: maxSeq + 1,
          description: '',
          isRequire: 'N'
        });

        setDetailLoading(false);
        setIsViewMode(false);
        // Sử dụng requestAnimationFrame để đảm bảo DOM đã được update
        requestAnimationFrame(() => {
          update(record);
        });
      } else {
        ToastService.error(res?.error || 'Không thể lấy thông tin cấu hình');
        setDetailLoading(false);
      }
    } catch (e: any) {
      ToastService.error('Có lỗi khi lấy thông tin cấu hình: ' + (e?.message || 'Unknown error'));
      setDetailLoading(false);
    } finally {
      // ensure spinner closes if we exited early before data load
      setDetailLoading(false);
    }
  };

  const handleView = async (rowData: any) => {
    setAgreementConfigureEnumIdError(null);
    try {
      setDetailLoading(true);
      const agreementPartyTypeConfId = rowData.agreementPartyTypeConfId;
      if (!agreementPartyTypeConfId) {
        ToastService.error('Không tìm thấy ID cấu hình');
        return;
      }
      const res = await Service.get(agreementPartyTypeConfId);
      if (res && res.success === 'Y' && res.record) {
        const record = res.record;
        const itemsData = res.items || [];
        setCurrentAgreementConfigureEnumId(record.agreementConfigureEnumId);
        const recordEnumId = record.agreementConfigureEnumId || '';
        setAgreementConfigureEnumIdValue(recordEnumId);
        if (recordEnumId) {
          setAgreementConfigureEnumIdError(null);
        }
        setItems(itemsData || []);
        const maxSeq = itemsData && itemsData.length > 0
          ? Math.max(...itemsData.map((item: any) => item.sequenceNum || 0))
          : 0;
        setNewItem({
          sequenceNum: maxSeq + 1,
          description: '',
          isRequire: 'N'
        });
        setDetailLoading(false);
        setIsViewMode(true);
        requestAnimationFrame(() => {
          view(record);
        });
      } else {
        ToastService.error(res?.error || 'Không thể lấy thông tin cấu hình');
        setDetailLoading(false);
      }
    } catch (e: any) {
      ToastService.error('Có lỗi khi lấy thông tin cấu hình: ' + (e?.message || 'Unknown error'));
      setDetailLoading(false);
    } finally {
      setDetailLoading(false);
    }
  };

  const handleCreate = () => {
    setCurrentAgreementConfigureEnumId(null);
    setAgreementConfigureEnumIdValue('');
    setAgreementConfigureEnumIdError(null);
    setItems([]);
    setNewItem({
      sequenceNum: 1,
      description: '',
      isRequire: 'N'
    });
    setIsViewMode(false);
    form?.reset?.();
    // Sử dụng requestAnimationFrame để đảm bảo DOM đã được update
    requestAnimationFrame(() => {
      create();
    });
  };

  const tableHeaderWithButton = (
    <div className="flex justify-content-between align-items-center">
      <span className="text-xl font-bold">{totalRecords} loại tài liệu</span>
      <Button
        icon="pi pi-plus"
        label="Thêm loại tài liệu"
        severity="success"
        onClick={handleCreate}
        size="small"
      />
    </div>
  );

  const { render: renderDataTable, reloadLazyData } = useDataTable({
    tableHeader: tableHeaderWithButton,
    dataKey,
    columns: [
      { field: 'agreementConfigureName', header: 'Tên loại tài liệu', matchMode: 'contains', minWidth: 200 },
      { field: 'agreementConfigureEnumId', header: 'Mã loại tài liệu', matchMode: 'contains', minWidth: 150 },
      { field: 'agreementNoFormatEnum', header: 'Loại tài liệu', matchMode: 'contains', minWidth: 150 },
      { field: 'description', header: 'Mô tả', matchMode: 'contains', minWidth: 200 },
      {
        field: 'statusId',
        header: 'Trạng thái',
        minWidth: 130,
        dataType: 'custom',
        customCell(rowData: any): any {
          return statusBodyTemplate(rowData);
        }
      },
    ],
    indexColumnWidth: 45,
    actionColumnWidth: 90,
    getList(lazyLoadEvent: any): Promise<any> {
      let eventData = lazyLoadEvent;
      if (typeof lazyLoadEvent === 'string') {
        try {
          eventData = JSON.parse(lazyLoadEvent);
        } catch (e) {
          eventData = { first: 0, rows: 20, filters: {} };
        }
      }
      if (!eventData.filters) eventData.filters = {};
      if (statusFilter) {
        if (Array.isArray(statusFilter)) {
          eventData.filters.statusId = { value: statusFilter, matchMode: 'in' };
        } else {
          eventData.filters.statusId = { value: statusFilter, matchMode: 'equals' };
        }
      }
      return Service.getList(JSON.stringify(eventData)).then(result => {
        setTotalRecords(result.totalRecords || result.totalCount || 0);
        if (result.listData && !result.list) {
          result.list = result.listData;
        }
        return result;
      });
    },
    initActions(items: Array<any>) {
      if (items) {
        items.forEach(item => {
          const statusId = item.statusId;
          const actions: any[] = [

          ];

          // Hiển thị nút theo trạng thái
          if (statusId === 'AGT_CFG_ACTIVE') {
            actions.push({
              icon: 'pi pi-stop',
              title: 'Ngừng sử dụng',
              className: 'p-button-warning',
              command: () => handleExpire(item)
            });
            actions.push({ icon: 'pi pi-eye', title: 'Xem', className: 'p-button-secondary', command: () => handleView(item) });
            actions.push({ icon: 'pi pi-pencil', title: 'Sửa', className: 'p-button-info', command: () => handleEdit(item) });
          } else if (statusId === 'AGT_CFG_INACTIVE') {
            actions.push({
              icon: 'pi pi-play',
              title: 'Sử dụng lại',
              className: 'p-button-success',
              command: () => handleActivate(item)
            });
            actions.push({ icon: 'pi pi-eye', title: 'Xem', className: 'p-button-secondary', command: () => handleView(item) });
            actions.push({ icon: 'pi pi-pencil', title: 'Sửa', className: 'p-button-info', command: () => handleEdit(item) });
          } else if (statusId === 'AGT_CFG_CREATED') {
            actions.push({
              icon: 'pi pi-trash',
              title: 'Xóa',
              className: 'p-button-danger',
              command: () => handleDelete(item)
            });
            actions.push({ icon: 'pi pi-eye', title: 'Xem', className: 'p-button-secondary', command: () => handleView(item) });
            actions.push({ icon: 'pi pi-pencil', title: 'Sửa', className: 'p-button-info', command: () => handleEdit(item) });
          } else if (statusId === 'AGT_CFG_DELETED') {
            actions.push({
              icon: 'pi pi-refresh',
              title: 'Khôi phục',
              className: 'p-button-success',
              command: () => handleRestore(item)
            });
            actions.push({ icon: 'pi pi-eye', title: 'Xem', className: 'p-button-secondary', command: () => handleView(item) });
          }

          item.actions = actions;
        });
      }
    }
  });


  const itemDialogFooter = (
    <div className="flex justify-content-end gap-2">
      <Button label="Đóng" icon="pi pi-times" onClick={() => { setItemDialogVisible(false); setEditingItem(null); }} className="p-button-text" />
      <Button label="Lưu" icon="pi pi-check" onClick={handleSaveItem} autoFocus />
    </div>
  );

  // Ẩn actions trong dialog footer và trong bảng khi ở chế độ view
  useEffect(() => {
    const hideActions = () => {
      const dialog = document.querySelector('.p-dialog');
      if (!dialog) return;

      // Ẩn buttons trong footer
      const footer = dialog.querySelector('.p-dialog-footer');
      if (footer) {
        const actionButtons = footer.querySelectorAll('button');
        actionButtons.forEach((btn: any) => {
          const btnText = btn.textContent?.trim() || '';
          const btnLabel = btn.getAttribute('aria-label') || '';
          // Giữ lại button "Đóng", "Hủy", "X", ẩn các button khác như "Lưu", "Tạo", "Cập nhật"
          if (isViewMode) {
            if (btnText.includes('Đóng') || btnText.includes('Hủy') || btnLabel.includes('close') || btn.classList.contains('p-dialog-header-close')) {
              btn.style.display = '';
            } else if (btnText && !btnText.includes('Đóng') && !btnText.includes('Hủy')) {
              btn.style.display = 'none';
            }
          } else {
            btn.style.display = '';
          }
        });
      }

      // Ẩn buttons xóa trong bảng "Danh sách file đính kèm"
      const deleteButtons = dialog.querySelectorAll('button.p-button-danger, button[class*="p-button-danger"]');
      deleteButtons.forEach((btn: any) => {
        if (isViewMode) {
          btn.style.display = 'none';
        } else {
          btn.style.display = '';
        }
      });

      // Disable các input fields trong bảng khi ở chế độ view
      const tableInputs = dialog.querySelectorAll('table input, table textarea, table .p-checkbox');
      tableInputs.forEach((input: any) => {
        if (isViewMode) {
          if (input.disabled === undefined) {
            input.style.pointerEvents = 'none';
            input.style.opacity = '0.6';
          } else {
            input.disabled = true;
          }
        } else {
          if (input.disabled === undefined) {
            input.style.pointerEvents = '';
            input.style.opacity = '';
          } else if (input.hasAttribute('data-original-disabled')) {
            input.disabled = input.getAttribute('data-original-disabled') === 'true';
          }
        }
      });
    };

    // Chạy ngay lập tức
    hideActions();

    // Chạy lại sau các khoảng thời gian để đảm bảo dialog đã render
    const timers = [100, 300, 500].map(delay => setTimeout(hideActions, delay));

    // Sử dụng MutationObserver để theo dõi thay đổi trong DOM
    const observer = new MutationObserver(() => {
      hideActions();
    });

    const dialog = document.querySelector('.p-dialog');
    if (dialog) {
      observer.observe(dialog, { childList: true, subtree: true, attributes: true });
    }

    return () => {
      timers.forEach(timer => clearTimeout(timer));
      observer.disconnect();
    };
  }, [isViewMode]);

  return (
    <div className="card border-none" style={{ background: 'linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%)' }}>
      <div className="col-12">
        <h3 className="m-0 mb-2">Quản lý loại tài liệu</h3>
      </div>
      <TabView activeIndex={activeTabIndex} onTabChange={(e) => { setActiveTabIndex(e.index); reloadLazyData(); }}>
        {tabs.map((tab, idx) => (
          <TabPanel key={tab.statusId} header={tab.label}>
            {renderDataTable()}
          </TabPanel>
        ))}
      </TabView>
      {renderDialogCrup()}

      <Dialog
        visible={itemDialogVisible}
        style={{ width: '32rem' }}
        header={editingItem?.sequenceNum ? "Sửa Item" : "Thêm Item"}
        modal
        className="p-fluid"
        footer={itemDialogFooter}
        onHide={() => { setItemDialogVisible(false); setEditingItem(null); }}
      >
        {editingItem && (
          <>
            <div className="field">
              <label htmlFor="sequenceNum">Số thứ tự <span className="text-red-500">*</span></label>
              <InputNumber
                id="sequenceNum"
                value={editingItem.sequenceNum || 1}
                onValueChange={(e) => setEditingItem({ ...editingItem, sequenceNum: e.value || 1 })}
                min={1}
              />
            </div>
            <div className="field">
              <label htmlFor="description">Mô tả</label>
              <InputText
                id="description"
                value={editingItem.description || ''}
                onChange={(e) => setEditingItem({ ...editingItem, description: e.target.value })}
                placeholder="Nhập mô tả"
              />
            </div>
            <div className="field-checkbox">
              <Checkbox
                inputId="isRequire"
                checked={editingItem.isRequire === 'Y'}
                onChange={(e) => setEditingItem({ ...editingItem, isRequire: e.checked ? 'Y' : 'N' })}
              />
              <label htmlFor="isRequire" className="ml-2">Bắt buộc</label>
            </div>
          </>
        )}
      </Dialog>

      <Dialog
        header={null}
        visible={detailLoading}
        modal
        closable={false}
        closeOnEscape={false}
        dismissableMask={false}
        style={{ width: '32rem' }}
        onHide={() => setDetailLoading(false)}
      >
        <div className="flex flex-column align-items-center justify-content-center py-6">
          <i className="pi pi-spin pi-spinner mb-3" style={{ fontSize: '2.8rem', color: '#2563EB' }} />
          <div className="text-center text-xl font-semibold mb-1" style={{ color: '#2563EB' }}>
            Đang tải dữ liệu cấu hình...
          </div>
          <small className="text-center text-gray-500">Vui lòng đợi trong giây lát</small>
        </div>
      </Dialog>
    </div>
  );
};

const toDateValue = (value: any): Date | null => {
  if (!value) return null;
  if (value instanceof Date) return value;

  if (typeof value === 'number') {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  if (typeof value === 'string') {
    const normalized = value.includes('T') ? value : value.replace(' ', 'T');
    const date = new Date(normalized);
    if (!isNaN(date.getTime())) return date;
    const asNumber = Number(value);
    if (!Number.isNaN(asNumber)) {
      const dateFromNumber = new Date(asNumber);
      return isNaN(dateFromNumber.getTime()) ? null : dateFromNumber;
    }
    return null;
  }

  if (typeof value === 'object') {
    if (value?.time) {
      const date = new Date(value.time);
      return isNaN(date.getTime()) ? null : date;
    }
    if (value?.date) {
      const date = new Date(value.date);
      return isNaN(date.getTime()) ? null : date;
    }
  }

  return null;
};
export { TemplateDocumentConfig } from './tai-lieu-mau';

